import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResearchDemandDetailFilter extends BaseModel {
  static override constructorName = 'ResearchDemandDetailFilter'

  'filter_name': string = ''
  'value_name': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResearchDemandDetailFilter)
